export enum EducationDocumentType {
    HighSchoolDiploma = 10,
    CollegeDiploma = 20,
    UniversityDiploma = 30,
    Certificate = 40
}